import * as React from "react"
import styled from 'styled-components';
import { Button } from "react-bootstrap";
import { useConfig } from "../../../hooks/use-config"

const StyledHeroContainer = styled("div")`

.hero {
    background-image: linear-gradient(to right bottom,#051937,#004d7a,#155055,#135f40,#567512) !important;
    width: 100%;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    height: 450px;
    margin-top:-40px
  }

    @media(max-width: 574px) {
        .hero {
            max-width: 100%;
        }
    }

    @media (min-width: 1200px){
        .container, .container-lg, .container-md, .container-sm, .container-xl {
            max-width: 100%;
        }
    }
`

const CompareHero = () => {
    const { clearout: clearoutConfig } = useConfig()

    return (
        <StyledHeroContainer>
            <div className="hero">
                <div className="text-center mt-5 py-5">
                    <h1 className="mt-4 fw-bolder text-white">Email Verifier Alternatives</h1>
                    <p className="text-white">Compare Clearout with other verifiers.</p>
                    <Button href={clearoutConfig.app.registerUrl} target="_blank" className="btn btn-primary btn-free-credits fw-bold px-4">Sign Up For a Free Trial</Button>
                    <div className="text-white fs-6">No Credit Card Required</div>
                </div>
            </div>
        </StyledHeroContainer>
    )
}

export default CompareHero;